import Image from 'next/image';
import SC from './style';

const QualiopiLogo: React.FC = () => {
  const downloadPDF = () => {
    const link = document.createElement('a');
    link.href = '/HAPPY_NEURON-Certificat_qualiopi.pdf';
    link.download = 'Happyneuron-Certificat_qualiopi.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <SC.DivQualiopiWrapper>
      <SC.DivQualiopiLogo onClick={downloadPDF}>
        <Image alt="Qualiopi" src="/certificate.png" width="210" height="75" />
        <SC.PText>
          La certification Qualité a été délivrée au titre de la catégorie :{' '}
          <strong>Actions de Formation</strong>
        </SC.PText>
      </SC.DivQualiopiLogo>
    </SC.DivQualiopiWrapper>
  );
};

export default QualiopiLogo;
